import clsx from 'clsx'
import { Typography } from 'components'
import { TypographyTypes } from 'interfaces'
import React from 'react'

interface RadioCardProps {
	title: string
	description: string
	checked: boolean
	onChange: () => void
	id: string
	readOnly?: boolean
}

export const RadioCard: React.FC<RadioCardProps> = ({
	title,
	description,
	checked,
	onChange,
	id,
	readOnly = false
}) => {
	return (
		<div
			className={`flex items-start justify-between border border-gray-200 p-4 rounded-lg ${
				!readOnly ? 'cursor-pointer hover:border-blue-primary' : ''
			}`}
			onClick={!readOnly ? onChange : undefined}
			onKeyDown={
				!readOnly
					? e => {
							if (e.key === 'Enter' || e.key === ' ') {
								onChange()
							}
					  }
					: undefined
			}
			role={!readOnly ? 'radio' : 'presentation'}
			aria-checked={checked}
			tabIndex={!readOnly ? 0 : undefined}
		>
			<div className="flex-1">
				<div className="flex items-center justify-between w-full mb-4">
					<Typography
						title={title}
						type={TypographyTypes.h3}
						className="text-black font-medium"
						fontLeading="15/18"
					/>
					<div className="relative flex items-center justify-center">
						<div
							className={`w-5 h-5 rounded-full border-2 ${
								checked ? 'border-blue-primary' : 'border-gray-300'
							} flex items-center justify-center`}
						>
							{checked && (
								<div className="w-2 h-2 rounded-full bg-blue-primary" />
							)}
						</div>
						<input
							id={id}
							name="tag-options"
							type="radio"
							checked={checked}
							onChange={!readOnly ? onChange : undefined}
							className={clsx(
								'absolute opacity-0 w-5 h-5',
								!readOnly && 'cursor-pointer'
							)}
							disabled={readOnly}
						/>
					</div>
				</div>
				<Typography
					title={description}
					type={TypographyTypes.p}
					className="text-gray-500 font-normal text-sm"
					fontLeading="15/22"
				/>
			</div>
		</div>
	)
}

RadioCard.defaultProps = {
	readOnly: false
}
